<template>
    <div class="domain-form-container">
        <h4 class="text-muted">
            {{ $t("message.generics.message.domainConfig") }}
        </h4>

        <form @submit.prevent="updateAccountDomain" class="domain-form">
            <v-text-field
                :label="$t('message.generics.message.domain')"
                v-validate="'required'"
                v-model="domain"
                :name="$t('message.generics.message.domain').toLowerCase()"
                :error-messages="
                    errors.collect(
                        $t('message.generics.message.domain').toLowerCase()
                    )
                "
            ></v-text-field>

            <transition name="fade" mode="out-in" appear>
                <button
                    v-if="domain !== currentDomain"
                    class="btn btn-primary btn-extra-round"
                    type="submit"
                >
                    {{ $t("message.generics.message.change") }}
                </button>
            </transition>
        </form>
    </div>
</template>

<script>
import EventBus from "@packages/event-bus";

export default {
    props: {
        currentDomain: {
            type: String,
        },
    },

    data() {
        return {
            domain: "",
            isUpdated: false,
        };
    },

    methods: {
        async updateAccountDomain() {
            EventBus.$emit("SHOW_SPINNER");

            try {
                await this.$api.account.updateAccountDomain(this.domain);

                this.$emit("updated");

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t(
                        "message.successMessages.message.domainChanged"
                    ),
                });
            } catch (error) {
                console.error(error);
            } finally {
                EventBus.$emit("CANCEL_SPINNER");
            }
        },
    },

    mounted() {
        this.domain = this.currentDomain;
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.domain-form-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.domain-form {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    align-items: center;
}

.v-input {
    width: 100%;
}

.fade-enter-active,
.fade-leave-active {
    opacity: 1;
    transition: all 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
